import React, { useState, useRef } from 'react';

import AddedColors from '@/features/materials/components/AddedColors';
import useClickOutside from '@/hooks/useClickOutside';

const ViewBaseColor = ({ colorInfo }) => {
	const [showColor, setShowColor] = useState(false);
	const colorRef = useRef(null);

	useClickOutside(colorRef, () => setShowColor(false));

	return (
		<div className="view-base-color position-relative">
			<p
				className="regular-14 gray_dark_01 mb-1 mb-3 cursor-pointer text-underline"
				onClick={() => setShowColor(!showColor)}
				ref={colorRef}
			>
				View base color
			</p>
			{showColor && (
				<AddedColors
					colorGroupResponseList={colorInfo?.colorGroupResponseList}
					colorResponse={
						Object.keys(colorInfo?.colorResponse).length > 0
							? colorInfo?.colorResponse
							: undefined
					}
					colorType={colorInfo?.colorType?.name}
					viewType="baseColorView"
				/>
			)}
		</div>
	);
};

export default ViewBaseColor;
